export enum ConvrTestName {
  MAIN_BUTTON_PART_1 = "MAIN_BUTTON_PART_1",
  MAIN_BUTTON_PART_2 = "MAIN_BUTTON_PART_2",
  MAIN_DESCRIPTION = "MAIN_DESCRIPTION",
  VISITS_COUNT = "VISITS_COUNT",
  SERVICE_COUNT = "SERVICE_COUNT",
  SERVICE_COLUMNS = "SERVICE_COLUMNS",
  FINAL_BUTTON_PART_1 = "FINAL_BUTTON_PART_1",
  FINAL_BUTTON_PART_2 = "FINAL_BUTTON_PART_2",
  PHONE_FORM_HEADER = "PHONE_FORM_HEADER",
  SERVICE_BACKGROUND = "SERVICE_BACKGROUND",
  SERVICE_ICONS = "SERVICE_ICONS",
  BUTTON_ANIMATION = "BUTTON_ANIMATION",
  BUTTON_FORM = "BUTTON_FORM",
  PHONE_INPUT_PADDING = "PHONE_INPUT_PADDING",
  PHONE_INPUT_BORDER = "PHONE_INPUT_BORDER",
  PHONE_INPUT_FONT_SIZE = "PHONE_INPUT_FONT_SIZE",
  NEXT_BUTTON = "NEXT_BUTTON",
  SERVICE_ORDER = "SERVICE_ORDER",
  WAY_TO_SHOW_SERVICES = "WAY_TO_SHOW_SERVICES"
}